import React, { Component } from "react";
import "./App.css";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newItem: "",
			list: [],
		};
	}

	updateInput(key, value) {
		//update react state
		this.setState({
			[key]: value,
		});
	}

	addItem() {
		//Create item with unique id
		const newItem = {
			id: 1 + Math.random(),
			value: this.state.newItem.slice(),
		};

		// copy of current list of items
		const list = [...this.state.list];

		//add new item to list
		list.push(newItem);

		//update state with new list and reset newItem input
		this.setState({
			list,
			newItem: "",
		});
	}

	deleteItem(id) {
		//copy current list of items
		const list = [...this.state.list];

		// filter out item being deleted
		const updatedList = list.filter((item) => item.id !== id);
		this.setState({ list: updatedList });
	}

	render() {
		return (
			<div>
				<h1 className="app-title">MY LIST</h1>
				<div className="container">
					<div
						style={{
							padding: 30,
							textAlign: "left",
							maxWidth: 500,
							margin: "auto",
						}}
					>
						

          <label>Add an Item...</label>
          <input
            type="text"
            placeholder="Type item here..."
            value={this.state.newItem}
            onChange={(e) => this.updateInput("newItem", e.target.value)}
            required
          />
          <button
            type="submit"
            className="add-btn"
            onClick={() => this.addItem()}
          >
            Add
          </button>
          <ul>
            {this.state.list.map((item) => {
              return (
                <li key={item.id}>
                  {item.value}
                  <button
                    className="delete_btn"
                    onClick={() => this.deleteItem(item.id)}
                  >
                    Delete
                  </button>
                </li>
              );
            })}
          </ul>
          <br />
        </div>
      </div>
    </div>
		);
	}
}

export default App;
